import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaBook, FaRocket, FaQuestionCircle, FaYoutube, FaTools, FaCompass, FaCode, FaShieldAlt } from 'react-icons/fa';

const links = [
  { to: '/dokumantasyon/baslangic', label: 'Başlangıç', icon: <FaRocket /> },
  { to: '/dokumantasyon/sss', label: 'SSS', icon: <FaQuestionCircle /> },
  { to: '/dokumantasyon/egitimler', label: 'Eğitimler', icon: <FaYoutube /> },
  { to: '/dokumantasyon/ozellikler', label: 'Özellikler', icon: <FaBook /> },
  { to: '/dokumantasyon/api', label: 'API', icon: <FaCode /> },
  { to: '/dokumantasyon/entegrasyonlar', label: 'Entegrasyonlar', icon: <FaTools /> },
  { to: '/dokumantasyon/kural-motoru', label: 'Kural Motoru', icon: <FaCompass /> },
  { to: '/dokumantasyon/guvenlik', label: 'Güvenlik', icon: <FaShieldAlt /> },
];

export default function Sidebar() {
  return (
    <aside
      className="w-64 min-h-screen bg-[var(--color-white)] border-r border-[var(--color-border)] shadow-md flex flex-col py-8 px-4"
      style={{ boxShadow: '2px 0 16px 0 rgba(70,184,127,0.07)' }}
    >
      <h2 className="text-2xl font-bold text-[var(--color-primary)] mb-8 text-center tracking-tight">Dokumantasyon</h2>
      <nav className="flex flex-col gap-2">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2 rounded-lg font-medium transition-colors group ${
                isActive
                  ? 'bg-[var(--color-primary)] text-white shadow'
                  : 'text-[var(--color-black)] hover:bg-[var(--color-secondary)] hover:text-white'
              }`
            }
            style={({ isActive }) =>
              isActive
                ? { boxShadow: '0 2px 12px 0 rgba(0,68,102,0.08)' }
                : {}
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={`text-lg transition-colors ${
                    isActive
                      ? 'text-white'
                      : 'text-[var(--color-primary)] group-hover:text-white'
                  }`}
                >
                  {link.icon}
                </span>
                {link.label}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
